import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';
import {
	find, get, set, isEqual, isNull,
} from 'lodash';
import { Button } from 'react-bootstrap';
import moment from 'moment-timezone';
import utils from '@utils';
import { JOB_TYPES_MAP, JOB_POSTED_TYPES } from '@utils/constants';

class JobFormatter extends Component {
	shouldComponentUpdate = ({
		row,
		timeZone,
		jobType,
		query,
	}) => {
		const {
			ClientName,
			ProjectName,
			Id,
			JobEventRecurrenceRuleId,
		} = row;
		const lastProps = this.props;

		return (
			!isEqual(ClientName, lastProps.row.ClientName)
			|| !isEqual(ProjectName, lastProps.row.ProjectName)
			|| !isEqual(Id, lastProps.row.Id)
			|| !isEqual(JobEventRecurrenceRuleId, lastProps.row.JobEventRecurrenceRuleId)
			|| !isEqual(timeZone, lastProps.timeZone)
			|| !isEqual(jobType, lastProps.jobType)
			|| !isEqual(query, lastProps.query)
		);
	}

	renderPostDate = () => {
		const {
			timeZone,
			row: {
				PostAtDateTime,
				Posted,
				PostedDate,
				CreateDateUTC,
				PostedType,
				PostedGroupName,
			},
		} = this.props;

		const display = {
			status : '',
			date   : PostAtDateTime || PostedDate,
		};
		const now = moment().utc().format();

		if (
			Posted && (
				PostedType === JOB_POSTED_TYPES.ALL
				|| PostedType === JOB_POSTED_TYPES.ALL_MINUTES_CONSTRAINT
				|| PostedType === JOB_POSTED_TYPES.ALL_WEEKDAY_CONSTRAINT
			)
		) set(display, 'status', now > (PostAtDateTime || PostedDate) ? 'Posted,' : 'Will be posted on');

		if (
			Posted && (
				PostedType === JOB_POSTED_TYPES.ALL_GROUPS
			)
		) set(display, 'status', now > (PostAtDateTime || PostedDate) ? 'Posted to all groups,' : 'Will be posted to all groups on');

		if (
			Posted && (
				PostedType === JOB_POSTED_TYPES.GROUPS
			)
		) {
			set(display, 'status', now > (PostAtDateTime || PostedDate)
				? `Posted to ${PostedGroupName} group.`
				: `Will be posted to ${PostedGroupName} group on`);
		}

		if (!Posted) {
			set(display, 'date', CreateDateUTC);
			set(display, 'status', `Created${!isNull(display.date) ? ',' : ''}`);
		}
		return (
			<div className="post-date">
				<span>{display.status}</span>
				<If condition={!isNull(display.date)}>
					<span>
						{utils.parseUTCDateToTimeZone(display.date, timeZone).format('MMMM DD, YYYY h:mm A')}
					</span>
				</If>
			</div>
		);
	}

	handleManualAssign = (e) => {
		e.preventDefault();
		e.stopPropagation();

		const { onManualAssign } = this.props;
		onManualAssign();
	}

	render() {
		const {
			onManualAssign,
			jobType,
			query,
			cellClassName,
			hideAgencyName,
			linkComponent: LinkComponent,
			row: {
				Name,
				AgencyName,
				ClientName,
				ProjectName,
				Id,
				JobEventRecurrenceRuleId,
				Posted,
				ApplicantsApplied,
			},
		} = this.props;
		const viewType = get(find(JOB_TYPES_MAP, ['type', jobType]), 'viewType');

		return (
			<div className={classNames('job-formatter', cellClassName)}>
				<h4>{ClientName}</h4>
				<div className="flex flex-wrap">
					<span>Job Name:</span>
					<span>{Name}</span>
				</div>
				<div>
					<span>Project:</span>
					<span>{ProjectName}</span>
				</div>
				<div>
					<span>Job ID:</span>
					<span>
						<LinkComponent
							data-prevent-navigation
							to={{ pathname : `/jobs/${Id}` }}
						>
							{Id}
						</LinkComponent>
						<If condition={JobEventRecurrenceRuleId}>
							<span className="margin-left-5">
								(
								<LinkComponent
									data-prevent-navigation
									to={{
										pathname : `/jobs/list/${viewType}`,
										query    : {
											...query,
											recurrenceId : JobEventRecurrenceRuleId,
										},
									}}
								>
									{JobEventRecurrenceRuleId}
								</LinkComponent>
								)
							</span>
						</If>
					</span>
				</div>
				<If condition={onManualAssign}>
					<div>
						<span>Applicants:</span>
						<span>
							<Button
								bsStyle="link"
								className="padding-0 font-size-12"
								onClick={this.handleManualAssign}
							>
								{`${ApplicantsApplied} New Applicants`}
							</Button>
						</span>
					</div>
				</If>
				<If condition={!hideAgencyName}>
					<div>
						<span>Agency:</span>
						<span>{AgencyName}</span>
					</div>
				</If>
				<div className="status">
					<i
						className={classNames('margin-right-5 rkf', {
							'rkf-eye color-green-christi'    : Posted,
							'rkf-eye-hidden color-red-torch' : !Posted,
						})}
					/>
					{this.renderPostDate()}
				</div>
			</div>
		);
	}
}

JobFormatter.propTypes = {
	cellClassName  : PropTypes.string,
	linkComponent  : PropTypes.func,
	hideAgencyName : PropTypes.bool,
	jobType        : PropTypes.number,
	onManualAssign : PropTypes.func,
	query          : PropTypes.object,
	timeZone       : PropTypes.string,
	row            : PropTypes.object,
};

JobFormatter.defaultProps = {
	cellClassName  : '',
	query          : undefined,
	hideAgencyName : false,
	onManualAssign : undefined,
	linkComponent  : Link,
	jobType        : 0,
	timeZone       : '',
	row            : {},
};

export default JobFormatter;
